import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Card, Form, Icon, ButtonGroup, Button } from '@shopify/polaris';
import AppLinkItem from './AppLinkItem';

const propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string.isRequired,
  })),

  handleModalAction: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
}

const defaultProps = {
}

const BannerListForm = (props) => {

  const onAddNewItem = () => {
    props.handleModalAction("CREATE");
  }
  const onEditItem = (banner, index) => {
    props.handleModalAction("UPDATE", { ...banner, index, })
  }
  const onRemove = (banner, index) => {
    props.handleRemove({ ...banner, index, })
  }

  return (
    <div style={{ backgroundColor: "#DEE1E8", border: "1px solid #DEE1E8", borderRight: "none" }}>
      { props.items.map( (banner, index) => {
        if(banner._destroy) return null;
        return(
          <div key={index} className="" style={{ backgroundColor: "white" }}>
            <div className="flex justifyBetween alignItemsCenter p10">
              { `${banner.title} - ${banner.identifier}` }
              <ButtonGroup segmented>
                <Button onClick={ () => onEditItem(banner, index) } >{ I18n.t("actions.edit") }</Button>
                <Button onClick={ () => onRemove(banner, index) }>{ I18n.t("actions.delete") }</Button>
              </ButtonGroup>
            </div>
        </div>
        )
      })}

      <div className="pv10 pl10 bg-white" style={{ border: "1px solid #DEE1E8", borderRight: "none", borderBottom: "none", borderLeft: "none" }}>
        <Button onClick={ onAddNewItem } plain>
          Agregar banner
        </Button>
      </div>
    </div>
  )
};

BannerListForm.propTypes = propTypes;
BannerListForm.defaultProps = defaultProps;

export default BannerListForm;